import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { api } from '../utils/api';
import { toast } from 'sonner';

const FREQ_TEXT_COLORS = {
  "Apres chaque service": "#FFFFFF",
  "Apres chaque utilisation": "#FFFFFF",
  "1 fois par jour": "#0E2D43",
  "Tous les jours": "#0E2D43",
  "1 fois par semaine": "#0E2D43",
  "2 fois par semaine": "#FFFFFF",
  "1 fois par mois": "#FFFFFF",
  "1 fois par trimestre": "#FFFFFF",
  "1 fois par semestre": "#FFFFFF",
  "1 fois par an": "#0E2D43",
  "Selon le besoin": "#FFFFFF",
};

const Frequencies = () => {
  const [frequencies, setFrequencies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFrequencies();
  }, []);

  const loadFrequencies = async () => {
    try {
      const { data } = await api.get('/frequencies');
      setFrequencies(data);
    } catch (error) {
      toast.error('Echec du chargement des frequences');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="text-center py-12">Chargement...</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div data-testid="frequencies-page">
        <h1 className="text-3xl font-bold mb-8" style={{ color: '#0E2D43', fontFamily: 'Work Sans, sans-serif' }}>
          Frequences
        </h1>

        <div className="bg-white rounded-lg shadow overflow-hidden border" style={{ borderColor: '#E5E7EB' }}>
          <table className="w-full">
            <thead style={{ backgroundColor: '#0E2D43', color: '#FFFFFF' }}>
              <tr>
                <th className="px-6 py-3 text-left text-sm font-medium">Nom</th>
                <th className="px-6 py-3 text-left text-sm font-medium">Apercu</th>
                <th className="px-6 py-3 text-left text-sm font-medium">Ordre</th>
              </tr>
            </thead>
            <tbody>
              {frequencies.map((freq) => {
                const textColor = FREQ_TEXT_COLORS[freq.name] || '#000000';
                return (
                  <tr key={freq.id} data-testid={`frequency-row-${freq.id}`} className="border-t" style={{ borderColor: '#E5E7EB' }}>
                    <td className="px-6 py-4 font-medium" style={{ color: '#0E2D43' }}>
                      {freq.name}
                    </td>
                    <td className="px-6 py-4">
                      <div className="inline-block px-4 py-2 rounded text-sm font-bold text-center"
                        style={{ backgroundColor: freq.color_hex, color: textColor, minWidth: '160px' }}>
                        {freq.name}
                      </div>
                    </td>
                    <td className="px-6 py-4" style={{ color: '#6B7280' }}>
                      {freq.sort_order}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default Frequencies;
